import { FileBase } from '../FileBase';

export class FirstPartyData extends FileBase {}
